import * as Yup from "yup";

const createSchema = (issueDate?: string | null) =>
  Yup.object({
    code: Yup.string()
      .trim()
      .transform((v) => (v ? v.toUpperCase() : v))
      .min(4, "Code must be at least 4 characters")
      .max(50, "Code must be at most 50 characters")
      .matches(
        /^[A-Za-z0-9][A-Za-z0-9\-_/&]*[A-Za-z0-9]$/,
        "Code must start and end with a letter or number, and may only contain letters, numbers, hyphens, underscores, slashes, or &",
      )
      .optional(),
    dueDate: Yup.string()
      .optional()
      .test(
        "due-gte-issue",
        "Due date cannot be earlier than issue date.",
        (value) => {
          if (!value || !issueDate) return true;
          return value >= issueDate;
        },
      ),
  });

export default createSchema;
